import { render, staticRenderFns } from "./conversation-chat.vue?vue&type=template&id=a7f58b30&scoped=true"
import script from "./conversation-chat.vue?vue&type=script&lang=js"
export * from "./conversation-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f58b30",
  null
  
)

export default component.exports